import { 
    UPDATE_ZAKAT_CALC_FITRAH_DATA , 
    GET_ZAKAT_CALC_DATA , 
    RESET_FITRAH_DATA, 
    UPDATE_TOTAL_CALC , 
    UPDATE_GOLD_DATA , 
    RESET_GOLD_DATA, 
    UPDATE_GOLD_DATA_IN_USE ,
    UPDATE_GOLD_DATA_NOT_IN_USE ,
    UPDATE_INSURANCE_DATA , 
    UPDATE_SHARES_DATA,
    UPDATE_SAVINGS_DATA,
    ADD_NEW_SHARES_DATA,
    REMOVE_SHARES_DATA,
    REMOVE_INSURANCE_DATA,
    ADD_NEW_INSURANCE_DATA,
    UPDATE_INSURANCE_SOURCE_TYPE,
    UPDATE_SAVINGS_SOURCE_TYPE,
    UPDATE_GOLD_SOURCE_TYPE,
    REINITIALIZE_INSURANCE_DATA,
    UPDATE_NISAB_VALUE,
    REINITIALIZE_SAVINGS_DATA,
    ADD_NEW_SAVINGS_DATA,
    REMOVE_SAVINGS_DATA,
    UPDATE_SHARES_SOURCE_TYPE,
    REINITIALIZE_SHARES_DATA,
    UPDATE_BUSINESS_DATA,
    SUBMITTING_ZAKAT_CALC_FORM,
    ZAKAT_CALC_PURGE,
    UPDATE_SOURCE_OF_INCOME_CALC,
    UPDATE_BUSINESS_AMOUNT
} from '../constants';
import { config } from '../../common/constant';

const zakatCalcDefaultState = () => ({
    savings : { name: 'Savings', amount : 0.00 , accounts : [] , isEligible: true }, 
    gold : { name: 'Gold', amount : 0.00 , isEligible: false , accounts : {
        goldforusage : {
                weightgrms: 0.00,
                totalzakat: 0.00
            },
        goldnotforusage :
            {
                weightgrms: 0.00,
                totalzakat: 0.00
            }
    }},
    insurance : { name: 'Insurance', amount : 0.00 , policies : [] , isEligible: true },
    business : { 
        name: 'Business', 
        type : 'Trade', 
        amount : 0.00, 
        isEligible: false,
        currentAssets: { totalAmount: 0.0},
        currentAssetsToAdd: { totalAmount: 0.0 },
        currentAssetsToRemove: { totalAmount: 0.0 },
        currentLiabilities: { totalAmount: 0.0 },
        currentLiabilitiesToAdd: { totalAmount: 0.0 },
        ownershipSharePercentange: 0.0,
        zakatNetAssestDue: 0.0,
        totalZakat: 0.0,
        totalPayable: 0.0,
        hasErrors: false,
    },
    zakatfitrah: { 
        name: "Zakat Fitrah", 
        type: {
          normal: { rate: null, noOfPerson: 0, amount: 0.00 },
          premium: { rate: null, noOfPerson: 0, amount: 0.00 },
          variable: { rate: null, noOfPerson: 0, amount: 0.00 },
        },
        isEligible: true,
        amount: 0.0 
      },
    shares : { name: 'Shares', amount : 0.00 , sharesAmount: 0.00 , portfolios : [] , isEligible: false },
    isSubmitting: false,
    sourceOfIncome: null,
    totalAmount: 0,
    nisabValue: 0,
});

function reduceAmount(state = zakatCalcDefaultState(), array, type = '', action) {
    switch(type.toLowerCase()) {
        case 'savings': {        
            const amount = array.reduce(
                (acc, {amount, interest}) => acc + amount - interest, 0
            );

            return amount * (amount >= state.nisabValue 
                ? config.RATES.RATE_ON_TOTAL 
                : 0
            );
        }

        case 'insurance': {
            // const amount = array.reduce(
            //     (acc, {amount}) => acc + (amount >= state.nisabValue ? amount: 0), 0
            // );

            const amount = array.reduce((acc, {amount}) => acc + (amount ? amount: 0), 0);

            return amount * (amount >= state.nisabValue 
                ? config.RATES.RATE_ON_TOTAL 
                : 0
            );
        }

        case 'business': {
            const totalAmount = 
                state.business.currentAssets.totalAmount + 
                state.business.currentAssetsToAdd.totalAmount - 
                state.business.currentAssetsToRemove.totalAmount -
                state.business.currentLiabilities.totalAmount +
                state.business.currentLiabilitiesToAdd.totalAmount;

            return Math.abs(totalAmount * (
                totalAmount >= state.nisabValue 
                ? config.RATES.RATE_ON_TOTAL 
                : 0
            ) * (state.business.ownershipSharePercentange * 0.01)) ;
        }

        case 'zakatfitrah': {
            return { ...state }
        }

        case 'shares': {            
            const sharesAmount = array.reduce((acc, {amount}) => acc + amount, 0);

            const amount = sharesAmount >= state.nisabValue 
                            ? sharesAmount * config.RATES.RATE_ON_TOTAL 
                            : 0;

            return {sharesAmount, amount};
        }

        default: return 0;
    }
}

export default function zakatCalcReducer(state = zakatCalcDefaultState() , action) {

    switch(action.type) {

        /* ==== SAVINGS ==== */
                
        case REINITIALIZE_SAVINGS_DATA: {
            const amount = reduceAmount(state, [...state.savings.accounts], 'savings')

            return {
                ...state, 
                savings: { ...state.savings, amount, isEligible: !!amount }
            };
        }

        case ADD_NEW_SAVINGS_DATA: {
            const accountObj = {
                account : `account${state.savings.accounts.length}` , 
                amount : 0 , 
                interest : 0 
            }

            const accounts = [...state.savings.accounts, accountObj];

            return {...state, savings: {...state.savings, accounts}};
        }

        case UPDATE_SAVINGS_DATA: {
            const {index, amount: newAmount, interest, remark} = action.payload;

            if (index < 0 || index >= state.savings.accounts.length)
                return state;

            const accounts = [...state.savings.accounts];

            accounts[index] = {
                account : `account${index}` , 
                amount : newAmount, 
                interest : interest,
                remark : remark,
            }

            const amount = reduceAmount(state, accounts, 'savings');

            return {...state, savings: {...state.savings, amount, accounts, isEligible: !!amount}};
        }

        case UPDATE_SAVINGS_SOURCE_TYPE: {
            const { sourceType: type } = action.payload;

            return { ...state, savings: { ...state.savings, type } }
        }

        case REMOVE_SAVINGS_DATA: {
            const { index } = action.payload;

            if(index < 0 || index >= state.savings.accounts.length){
                return state;
            }

            const accounts = [...state.savings.accounts];
            accounts.splice(index, 1);

            for(let sIdx = index; sIdx < accounts.length; sIdx ++){
                accounts[sIdx].account = `account${sIdx}`;
            }

            const amount = reduceAmount(state, accounts, 'savings'); 

            return {...state, savings: {...state.savings, amount, accounts, isEligible: !!amount}};
        }

        /* ==== GOLD ==== */

        case UPDATE_GOLD_DATA: {
            return { ...state , ...{ gold: action.gold } };
        }

        case UPDATE_GOLD_DATA_IN_USE: {
            const { weightgrms, totalzakat } = action.payload;

            const amount = state.gold.accounts.goldnotforusage.totalzakat + totalzakat;

            return {
                ...state, 
                gold: {
                    ...state.gold,
                    amount,
                    isEligible: !!amount, 
                    accounts: {
                        ...state.gold.accounts,
                        goldforusage: { weightgrms, totalzakat }
                    }
                }
            }
        }

        case UPDATE_GOLD_DATA_NOT_IN_USE: {
            const { weightgrms, totalzakat } = action.payload;

            const amount = state.gold.accounts.goldforusage.totalzakat + totalzakat;

            return {
                ...state, 
                gold: {
                    ...state.gold,
                    amount,
                    isEligible: !!amount, 
                    accounts: {
                        ...state.gold.accounts,
                        goldnotforusage: { weightgrms, totalzakat }
                    }
                }
            }
        }

        case RESET_GOLD_DATA:
            return { ...state , ...{ gold: zakatCalcDefaultState().gold } };

        case UPDATE_GOLD_SOURCE_TYPE: {
            const { sourceType: type } = action.payload;

            return { ...state, gold: { ...state.gold, type } }
        }

        /* ==== FITRAH ==== */

        case UPDATE_ZAKAT_CALC_FITRAH_DATA: {

          const { fitrahType, data } = action.payload;

          const currentData = state;
          const currentTotal = state.zakatfitrah.amount;
    
          // Update specific fitrah type
          currentData.zakatfitrah.type[fitrahType] = data

          const fitrahTotal = Number(parseFloat(
            Number(currentData.zakatfitrah.type.normal.amount) + 
            Number(currentData.zakatfitrah.type.premium.amount) +
            Number(currentData.zakatfitrah.type.variable.amount)
          ).toFixed(2));
            
          currentData.zakatfitrah.amount = fitrahTotal;

          let zakatTotal = Number(currentData.totalAmount);

          // Update total amount
          zakatTotal = zakatTotal - Number(currentTotal > 0 ? currentTotal : 0);

          return { ...state, totalAmount: zakatTotal + fitrahTotal };

        }
        
        case RESET_FITRAH_DATA:
            return { ...state , ...{ zakatfitrah: zakatCalcDefaultState().zakatfitrah } };

        /* ==== INSURANCE ==== */

        case ADD_NEW_INSURANCE_DATA:{
            return {
                ...state,
                insurance: {
                    ...state.insurance,
                    policies: [
                        ...state.insurance.policies, 
                        {
                            account : `policy${state.insurance.policies.length}` , 
                            amount : 0 
                        }
                    ]
                }
            };
        }

        case REINITIALIZE_INSURANCE_DATA: {
            const amount = reduceAmount(state, [...state.insurance.policies], 'insurance');

            return {
                ...state, 
                insurance: { ...state.insurance, amount, isEligible: !!amount }
            }; 
        }

        case UPDATE_INSURANCE_DATA:{
            const {index, type, amount: newAmount, remark } = action.payload;

            const policies = [...state.insurance.policies ];

            policies[index] = {
                account : `policy${index}`, 
                type: type,
                amount: newAmount,
                remark : remark,
            };
            
            const amount = reduceAmount(state, policies, 'insurance');

            return {...state, insurance: { ...state.insurance, amount, policies, isEligible: !!amount } };
        }

        case REMOVE_INSURANCE_DATA: {
            const { index } = action.payload;

            const policies = [...state.insurance.policies];

            policies.splice(index, 1);

            for(let sIdx = index; sIdx < policies.length; sIdx ++){
                policies[sIdx].account = `policy${sIdx}`;
            }

            const amount = reduceAmount(state, policies, 'insurance');

            return { ...state, insurance: { ...state.insurance, policies, amount, isEligible: !!amount } }
        }

        case UPDATE_INSURANCE_SOURCE_TYPE: {
            const { sourceType: type } = action.payload;

            return { ...state, insurance: { ...state.insurance, type } }
        }

        /* ==== SHARES ==== */

        case REINITIALIZE_SHARES_DATA: {
            const {sharesAmount, amount} = reduceAmount(state, [...state.shares.portfolios], 'shares');

            return {
                ...state,
                shares: { ...state.shares, amount, sharesAmount, isEligible: !!amount }
            }
        }

        case ADD_NEW_SHARES_DATA:{
            return {
                ...state,
                shares: {
                    ...state.shares,
                    portfolios: [
                        ...state.shares.portfolios, 
                        {
                            account : `portfolio${state.shares.portfolios.length}` , 
                            amount : 0 
                        }
                    ]
                }
            };
        }

        case UPDATE_SHARES_DATA:{
            const {index, amount: newAmount, remark } = action.payload;

            const portfolios = [...state.shares.portfolios];

            portfolios[index] = {
                account : `portfolio${index}` , 
                amount : newAmount,
                remark : remark,
            };

            const sharesAmount = portfolios.reduce((acc, {amount}) => acc + amount, 0);
            const amount = sharesAmount >= state.nisabValue ? sharesAmount * config.RATES.RATE_ON_TOTAL : 0;

            return { ...state, shares: { ...state.shares, portfolios, amount, sharesAmount, isEligible: !!amount } };
        }
        
        case REMOVE_SHARES_DATA: {
            const { index } = action.payload;

            const portfolios = [...state.shares.portfolios];

            portfolios.splice(index, 1);

            for(let sIdx = index; sIdx < portfolios.length; sIdx ++){
                portfolios[sIdx].account = `portfolio${sIdx}`;
            }

            const sharesAmount = portfolios.reduce((acc, {amount}) => acc + amount, 0);
            const amount = sharesAmount >= state.nisabValue ? sharesAmount * config.RATES.RATE_ON_TOTAL : 0;

            return { ...state, shares: { ...state.shares, portfolios, amount, sharesAmount, isEligible: !!amount } }
        }

        case UPDATE_SHARES_SOURCE_TYPE: {
            const { sourceType: type } = action.payload;

            return { ...state, shares: { ...state.shares, type } }
        }

        /* ==== BUSINESS ==== */
        case UPDATE_BUSINESS_DATA: {
            const { data } = action.payload;

            const nextState = {...state, business: {...state.business, ...data}};

            nextState.business.amount = reduceAmount(nextState, null, 'business');
            nextState.totalAmount = nextState.gold.amount + 
                                    nextState.insurance.amount +
                                    nextState.savings.amount +
                                    nextState.shares.amount +
                                    nextState.business.amount +
                                    nextState.zakatfitrah.amount;
                                    
            nextState.business.isEligible = nextState.business.amount > 0;
            nextState.isEligible = nextState.totalAmount > 0;

            return nextState;
        }

        /* ==== NISAB ==== */

        case UPDATE_NISAB_VALUE:
            const {value: nisabValue} = action.payload;

            return {...state, nisabValue}
        
        /* ==== COMMON ==== */

        case SUBMITTING_ZAKAT_CALC_FORM: {
            const { data } = action.payload;

            return {...state, isSubmitting: data}
        }

        case UPDATE_TOTAL_CALC:
            return { ...state , totalAmount: action.total };
        
        case UPDATE_SOURCE_OF_INCOME_CALC:
            return { ...state, ...{ sourceOfIncome: action.source } }

        case GET_ZAKAT_CALC_DATA:
            return state;
    
        case ZAKAT_CALC_PURGE:
            return zakatCalcDefaultState();

        case UPDATE_BUSINESS_AMOUNT:
            const amount = parseFloat(action.payload) || 0;
            return {
                ...state,
                business: {
                ...state.business,
                amount: amount,
                totalPayable: amount,
                totalZakat: amount,
                zakatNetAssestDue: amount,
                isEligible: amount> 0
                }
            };
        default:
            return state;
    }

}